import { useMount } from '@tiger/hooks';
import { FC } from 'react';
import { $Formutil, FormGroup, withForm } from 'react-bootstrap-formutil';
import Phone from 'components/forms/Phone';
import Telcodes from 'components/Telcodes';

export interface TelPhoneProps {
    value?: string;
    $formutil: $Formutil<{
        tel_code: string;
        phone: string;
    }>;
    onChange?(value?: string | object): void;
    disabled?: boolean;
}

// Job页面：填写 Compliance（公司信息）的时候记录<公司电话>，字段需要拼接 phone 和 tel_code使用，具体查看本组件引用。
const TelPhone: FC<TelPhoneProps> = ({ $formutil, onChange, disabled, value }) => {
    const handleChange = () => {
        $formutil.$getField('phone')?.$validate();

        // 拼接 tel_code 和 phone
        if (onChange) {
            setTimeout(() => {
                const { $invalid, $params } = $formutil;

                if ($invalid) {
                    if (value !== '') {
                        onChange('');
                    }
                } else {
                    onChange!([$params.tel_code, $params.phone].join(' '));
                }
            });

            onChange();
        }
    };

    useMount(() => {
        if (value) {
            const phoneInfo = value.split(' ');

            $formutil.$setValues({
                tel_code: phoneInfo[0] || '',
                phone: phoneInfo[1] || ''
            });
        }
    });

    return (
        <div className="d-flex">
            <FormGroup
                className={disabled ? undefined : 'flex-grow-1'}
                name="tel_code"
                $defaultValue="1"
                required
                $onFieldChange={handleChange}>
                <Telcodes disabled={disabled} />
            </FormGroup>
            <Phone disabled={disabled} name="phone" onChange={handleChange} />
        </div>
    );
};

export default withForm(TelPhone);
